import { createContext } from 'react';

const userContext = createContext({ currentUser: {}, globalUsers: [] });

export { userContext };